import bluePhoneIcon from "assets/icons/bluePhoneIcon.svg";
import avashologo from "assets/images/logo.svg";
import { CustomButton } from "components/component-styles/buttons/index.styled";
import { FormContainer } from "components/component-styles/alignment";
import FormikControl from "components/form/formikControl";
import Shape from "components/layout/authShapes";
import { Form, Formik } from "formik";
import useWindowDimensions from "hooks/useWindowDimensions";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Users from "services/apis/usersAPI";
import { convertToEnglishNumber } from "utils/validate";
import * as Yup from "yup";
import {
  Container,
  HeaderLogin,
  LoginContainer,
  LoginFormcontainer,
  LogoContainer,
  SignUpInvitation,
} from "./index.styled";
export default function ForgotPassword() {
  const navigate = useNavigate();
  const dim = useWindowDimensions();
  const initialValues = { mobile: "" };
  const [submitOnce, setSubmitOnce] = useState(true);

  const onSubmit = async (values) => {
    const reqObj = {
      mobile: convertToEnglishNumber(values.mobile),
    };

    if (submitOnce) {
      setSubmitOnce(false);

      const response = await new Users(reqObj).postSendValidationCode();

      if (response.type) {
        setSubmitOnce(true);
        toast.success(response.data.data);
        localStorage.setItem("mobile", convertToEnglishNumber(values.mobile));
        navigate("/submit-forgot-pass");
      } else {
        setSubmitOnce(true);
        toast.error(response.message);
      }
    }
  };

  const validationSchema = Yup.object({
    mobile: Yup.string()
    .required("شماره تلفن الزامی می‌باشد")
    .matches(/[۰۱۲۳۴۵۶۷۸۹0-9]/, 'لطفا عدد وارد کنید')
    .max(11, 'تعداد ارقام وارد شده نباید بیشتر از ۱۱ باشد.')
    .min(11, 'تعداد ارقام وارد شده نباید کمتر از ۱۱ باشد.'),
  });

  return (
    <>
      <Helmet>
        <title>فراموشی رمز عبور</title>
      </Helmet>

      <LoginContainer>
        <LogoContainer color="#89BEFF">
          <div>
            <h2>آواشو</h2>
            <img src={avashologo} alt="logo" />
          </div>
        </LogoContainer>
        <Container>
          <LoginFormcontainer>
            <HeaderLogin color="#27548C">فراموشی رمز عبور</HeaderLogin>
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmit}
              validationSchema={validationSchema}
              placeholderColor="#27548C"
              fontColor=""
            >
              {(formik) => {
                return (
                  <FormContainer>
                    <Form>
                      <FormikControl
                        control="input"
                        name="mobile"
                        width="388px"
                        placeholder="شماره موبایل"
                        label="شماره موبایل"
                        rightIcon={bluePhoneIcon}
                        placeholderColor="#27548C"
                        fontColor="#27548C"
                        borderColor="#E9EBF8"
                      />
                      <div className="button-wrapper">
                        <CustomButton
                          width="388px"
                          color="#fff"
                          height="56px"
                          radius="12px"
                          disabled={!formik.isValid}
                          width360="320px"
                          width417="328px"
                          background="#6CAEFF"
                          borderColor="#6CAEFF"
                          backgroundHover="#FFFFFF"
                          colorHover="#6CAEFF"
                          borderColorHover="#6CAEFF"
                          type="submit"
                        >
                          ارسال کد تایید
                        </CustomButton>
                      </div>
                      <SignUpInvitation>
                        <div>
                          <span> برگشت به صفحه </span>

                          {dim.width > 1024 ? (
                            <Link to="/login"> ورود </Link>
                          ) : (
                            <Link to="/login"> ورود </Link>
                          )}
                        </div>
                      </SignUpInvitation>
                    </Form>
                  </FormContainer>
                );
              }}
            </Formik>
          </LoginFormcontainer>
          <Shape />
        </Container>
      </LoginContainer>
    </>
  );
}
